<template>
  <div class="create-tag modal">
    <div class="modal__container">
      <div class="create-tag">
        <div class="modal__top">
          <h1>{{ $t('error') }}</h1>
          <button
            class="modal__close-btn"
            @click="closeModal"
          >
            ✕
          </button>
        </div>

        <div class="modal__body">
          <div
            v-for="(item, key) in error"
            :key="item.id"
            style="width: 100%"
          >
            <span style="text-transform: capitalize">{{ removeBrackets(key) }} : </span>
            <span>{{ item[0] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ErrorModal',
  props: {
    error: {
      type: Object,
      required: true,
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    removeBrackets(value) {
      return value.replace(/\[|\]/g, '').replace(/\d+/g, '');
    }
  }
};
</script>

<style lang="scss" scoped>
.create-tag {
  &.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 111;
    background: #161616;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal {
    &__container {
      background: #242424;
      padding: 20px;
      border-radius: 10px;
      min-width: 600px;
      min-height: 200px;
      max-width: 800px;
    }

    &__top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h1 {
        margin: 0
      }
    }

    &__body {
      display: flex;
      flex-wrap: wrap;
      column-gap: 20px;
      row-gap: 10px;
      margin-top: 20px;
      color: white;
      font-family: 'HalvarR';
    }

    &__input-container {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;


      label {
        gap: 8px;

        &:has(.name) {
          width: 100%
        }
      }

      .required {
        margin-top: 0;
      }
    }

    &__close-btn {
      background: transparent;
      color: white;
      border: none;
      font-size: 24px;
      padding: 0;
    }

    &__create-btn {
      width: 200px;
      height: 40px;
      border-radius: 8px;
      background: #ff2a00;
      color: #fff;
      font-size: 16px;
      border: none;
      font-family: HalvarR;
    }
  }
}
</style>
